<template>
  <div :class="classes">
    <slot name="default"></slot>
  </div>
</template>

<script>

export default {
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },
  computed: {
    classes () {
      let classes = [
        'web-scroll-view',
        'orientation-' + this.orientation
      ]

      return classes.join(' ')
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-scroll-view {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .web-scroll-view.orientation-horizontal {
    overflow-y: hidden;
    overflow-x: auto;
  }
}

</style>